<template>
  <div class="card" style="height: calc(28vh - 20px);bottom: 10px">
    <div class="card-title">
      <span
        @click="childOnShowDialog({ type: 6, selfAreaId: selfAreaId })"
        plain
        size="small">站点排名</span>
      <el-radio-group
        class="radio_group"
        @change="onSiteType"
        size="mini"
        v-model="siteType">
        <el-radio-button label="时"></el-radio-button>
        <el-radio-button label="日"></el-radio-button>
        <el-radio-button label="月" class="radio_button"></el-radio-button>
      </el-radio-group>
      <el-date-picker
        style="float: right;bottom: 0.625rem;width: 9.375rem"
        :clearable="false"
        class="datestyle"
        size="mini"
        v-model="siteRankAllTime"
        @change="onSiteRankAllTime"
        :type="
          siteType === '时' ? 'datetime' : siteType === '日' ? 'date' : 'month'
        "
        popper-class="datestyle2"
        placeholder="选择日期时间"
        :format="
          siteType === '时'
            ? 'yyyy-MM-dd HH'
            : siteType === '日'
            ? 'yyyy-MM-dd'
            : 'yyyy-MM'
        "
        default-time="12"
      >
      </el-date-picker>
    </div>
    <div class="box">
      <div class="Date">
        <div class="border_line">
          <div style="width: 5rem;text-align: left;">排名</div>
          <div style="width: 10rem;text-align: left;">站点名称</div>
          <div style="width: 6.25rem;text-align: left;">租车</div>
          <div style="width: 3.125rem;text-align: left;">还车</div>

        </div>
      </div>
      <div class="list" >
      <dv-scroll-board :config="config" :rowNum=5 />
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api'

export default {
  name: 'SiteRanking',
  data() {
    return {
      Timer: null,
      config: {},
      data: [],
      siteType: '日',
      orderBy: 'rent_num desc',
      siteRankAllTime: new Date(),
      tableLoading: false,
      tableData: null
    }
  },
  created() {
    // 2分钟刷新一次数据
    this.siteRankAll()
    this.Timer = setInterval(() => {
      this.siteRankAll()
    }, 120000)
  },
  watch: {
    selfAreaId(v, o) {
      this.siteRankAll()
    },
    siteRankType(v) {
      this.siteRankAll()
    }
  },
  props: {
    siteRankType: {
      default: null,
      type: [String, Number]
    },
    selfAreaId: {
      default: '',
      type: String
    }
  },
  methods: {
    childOnShowDialog(data) {
      console.log(data)
      this.$emit('singleRankMethod')
    },
    onSiteType() {
      this.onSiteRankAllTime()
    },
    onSiteRankAllTime() {
      if (!this.siteRankAllTime) {
        this.siteRankAll(true)
      } else {
        this.siteRankAll()
      }
    },
    // 排名
    siteRankAll(type) {
      const vm = this
      if (!this.selfAreaId) {
        this.config = {
          data: [],
          rowNum: 5
        }
        return
      }
      vm.tableLoading = true
      const format = vm.getSiteParams(vm.siteRankAllTime)
      const params = {
        selfAreaId: vm.selfAreaId,
        year: format[0],
        siteType: vm.siteType,
        orderBy: vm.orderBy
      }
      params.month = format[1]
      params.day = format[2]
      params.hour = format[3]
      params.dateTime = params.year + '-' + params.month + '-' + params.day
      if (vm.siteType === '时') {
        params.startTime = params.year + '-' + params.month + '-' + params.day + ' ' + params.hour + ':00:00'
        params.endTime = params.year + '-' + params.month + '-' + params.day + ' ' + params.hour + ':59:59'
      }
      if (vm.siteType === '日') {
        params.startTime = params.year + '-' + params.month + '-' + params.day + ' 00:00:00'
        params.endTime = params.year + '-' + params.month + '-' + params.day + ' 23:59:59'
      }
      if (vm.siteType === '月') {
        params.startTime = params.year + '-' + params.month + '-01' + ' 00:00:00'
        params.endTime = params.year + '-' + params.month + '-' + params.day + ' 23:59:59'
      }
      Api.siteRankAll(params)
        .then((res) => {
          if (res.code === 200) {
            vm.total = res.data.length
            vm.tableData = res.data.slice(0, 500).map((item, index) => {
              return [
                `<div style="position: absolute;margin-top: 5px;
                  line-height: 20px;text-align: center;background: #00DADA;color: black;
                  width: 20px;height: 20px;border-radius: 50%;border-bottom:110px;font-size: 12px;">
                ${index + 1}
                </div>`,
                item.siteName,
                item.rentNum,
                item.returnNum
              ]
            })
            vm.config = {
              data: vm.tableData,
              rowNum: 5
            }
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
        .catch((err) => {
          console.log(err)
          vm.tableLoading = false
        })
    },
    getSiteParams(data) {
      const vm = this
      const t = data ? vm.getTodayTime(data) : vm.getTodayTime()
      const format = t.split('-')
      return format
    },
    getTodayTime(date) {
      const day2 = date ? new Date(date) : new Date()
      day2.setTime(day2.getTime())
      return (
        day2.getFullYear() +
        '-' +
        (day2.getMonth() < 9
          ? '0' + (day2.getMonth() + 1)
          : day2.getMonth() + 1) +
        '-' +
        (day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate()) +
        '-' +
        day2.getHours() +
        '-' +
        day2.getMinutes()
      )
    }
  },
  beforeDestroy() {
    if (this.Timer) {
      clearInterval(this.Timer)
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #00dada !important;
  background: transparent !important;
  border-color: #00dada !important;
  box-shadow: -1px 0 0 0 #00dada !important;
}
/deep/.el-radio-button__inner {
  color: #00dada !important;
  background: transparent !important;
  border-color: #3e7878 !important;
  box-shadow: -1px 0 0 0 #3e7878 !important;
}
/deep/.el-input__inner {
  color: #00dada !important;
  background: transparent !important;
  border-color: #3e7878 !important;
}
.box {
  padding: 0 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .list {
    flex: 1;
    overflow: hidden;
    position: relative;
    bottom: 10px;
  }
  .Date {
    display: flex;
    flex-direction: row;
    bottom: 5px;
    flex: 0 0 39px;
    cursor: pointer;
    > div {
      flex: 1;
      text-align: center;
      p {
        margin-top: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 14px;
      }
      span {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 18px;
      }
    }
  }
  .bg {
    flex: 0 0 14px;
    display: block;
    margin: 10px 0;
    width: 100%;
  }
}
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  background: hsla(180, 100%, 43%, 0.1);
  border: solid 1px #3e7878;

  &::before,
  &::after {
    content: "";
    width: 15px;
    height: 15px;
    position: absolute;
    bottom: 0;
  }
  &::before {
    background: url("~@/assets/image/左下角.png");
    background-size: cover;
    left: 0;
  }
  &::after {
    background: url("~@/assets/image/右下角.png");
    background-size: cover;
    right: -1px;
    bottom: -1px;
  }
  .card-title {
    position: relative;
    flex-shrink: 0;
    height: 18px;
    padding: 16px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 16px;
    background: url("~@/assets/image/标题栏.png") no-repeat bottom;
    background-size:27.1875rem auto;
    .el-button {
      float: right;
      border: 1px solid #00dada;
      color: #00dada;
      line-height: 22px;
      font-size: 12px;
      text-align: center;
      padding: 0 12px;
      background: #052430;
      margin-top: -6px;
      margin-left: 10px;
    }
    > span {
      cursor: pointer;
      &.nopoint {
        cursor: default;
      }
    }
    .btn-group {
      float: right;
      margin-top: -6px;
      > div {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 4px;
        border: 1px solid #00dada;
        color: #00dada;
        line-height: 20px;
        font-size: 12px;
        text-align: center;
        margin-left: 10px;
        cursor: pointer;
        &.no_active {
          border-color: #3e7878;
          color: #00dada;
        }
      }
      .el-radio--mini {
        height: 24px;
        border: 1px solid #3e7878;
        line-height: 22px;
        padding: 0 6px;
        background: transparent;
        margin-right: 0;
        color: #00dada !important;
        /deep/ .el-radio__input {
          display: none;
        }
        /deep/ .el-radio__label {
          padding: 0;
          color: #00dada;
        }
        &:hover,
        &.is-checked {
          box-shadow: 0px 0px 8px 0px #00dada inset;
        }
      }
    }
    &::before,
    &::after {
      content: "";
      width: 15px;
      height: 15px;
      position: absolute;
      top: 0;
    }
    &::before {
      background-image: url("~@/assets/image/左上角.png");
      left: -1px;
      top: -1px;
      background-size: cover;
    }
    &::after {
      background-image: url("~@/assets/image/右上角.png");
      right: -1px;
      top: -1px;
    }
    span {
      position: relative;
      &::after {
        position: absolute;
        bottom: -7px;
        left: 0;
        content: "";
        height: 3px;
        width: 100%;
        background: #00dada;
      }
    }
  }
}
.mr8 {
  position: absolute;
  left: 90px;
  bottom: 18px;
}
.btn-group {
  text-align: right;
  margin-bottom: 16px;
}
/deep/.row-item {
  background: transparent !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background-color: transparent !important;
}
.radio_group{
  position: absolute;
  margin-left: 80px;
  bottom: 16px;
  background: transparent !important;
  color: #00dada;
}
::v-deep.border_line{
  border: 1px none #0c3444;
  line-height:35px;
  display:flex;
  height:35px;
  font-size:14px;
  margin-bottom: 10px;
  background: #0c3444;
  color: #00DADA;
  padding: 0px 10px;
}
::v-deep .ceil:nth-child(1) {
  width: 5rem!important;
}
::v-deep .ceil:nth-child(2) {
  width: 10rem!important;
}
::v-deep .ceil:nth-child(3) {
  width: 6.25rem!important;
}
::v-deep .ceil:nth-child(4) {
  width: 3.125rem!important;
}
</style>
